function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeWidth: 0.882
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 47.199h30.599v3.129h-30.6zM25.6 3H29v38.73l2.832 5.469h-9.066l2.833-5.53z",
  strokeLinejoin: "round",
  strokeWidth: 0.9995706
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.6 35.866H29",
  strokeWidth: 0.9995706
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.34 50.6v1.133L13.473 54M15.287 50.6v1.133L16.42 54M18.233 50.6v1.133L19.366 54M21.18 50.6v1.133L22.313 54M24.127 50.6v1.133L25.26 54M27.073 50.6v1.133L28.206 54M30.02 50.6v1.133L31.153 54M32.967 50.6v1.133L34.1 54M35.913 50.6v1.133L37.046 54M38.86 50.6v1.133L39.993 54M41.807 50.6v1.133L42.94 54"
}));

var SvgRake = function SvgRake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rake.5a01550e.svg";
export { ForwardRef as ReactComponent };